import { faStar } from '@fortawesome/pro-solid-svg-icons';

import { Button } from '@/components/ui/button/button.component';
import { Link } from '@/components/ui/link/link.component';
import { Skeleton } from '@/components/ui/skeleton.component';

interface AppointmentReviewButtonProps {
  id: string;
  isLoading: boolean;
}

export const AppointmentReviewButton = ({ id, isLoading }: AppointmentReviewButtonProps) => {
  if (isLoading) {
    return <Skeleton className="w-44 h-6" />;
  }

  return (
    <Button
      variant="text"
      startIcon={faStar}
      startIconSize="1x"
      startIconClassName="text-base text-gray-400"
      asChild
      className="w-auto self-start gap-2 px-0 py-2"
    >
      <Link prefetch={false} href={`/agendamentos/${id}/avaliar/`}>Avaliar atendimento</Link>
    </Button>
  );
};
